import { request } from '@/store/client'

/**
 * Validates an activation token
 */
export const validatePerishableToken = (token: string): Promise<{ email: string }> => {

  return request({
    url: '/user/validate-token',
    method: 'post',
    data: { token },
  })
    .then(response => response.data as { email: string })
    .catch((error) => {

      if (error.response) {
        if (error.response.status === 410) {
          throw new Error('TokenExpired')
        }

        if (error.response.status === 409) {
          throw new Error('TokenInvalid')
        }
      }

      throw error
    })
}
